<div class="example-container mat-elevation-z8" *ngIf="parentData">
  
    <div fxLayout="row" fxLayoutAlign="start center" fxFlex="1 0 auto">
      <i *ngIf="isApiUserDetails" class="material-icons md-48" style="color: #02488e;margin-left: 24px;font-size: 32px;cursor:pointer" color="accent" (click)="back()" matTooltip="{{getToolTip('icoBack')}}">
        arrow_circle_left
      </i>  
      <i *ngIf="datatableProp.isAdd" class="material-icons md-48" style="color: #02488e;margin-left: 24px;font-size: 32px;cursor:pointer" color="accent" (click)="addRecord()" matTooltip="{{getToolTip('icoAdd')}}">
        add_box
      </i>
      <mat-form-field style="margin-left: 50px;">
        <input matInput (ngModelChange)="applyFilter($event)" [(ngModel)]="parent.filterText">
        <mat-placeholder><mat-icon>search</mat-icon></mat-placeholder>
      </mat-form-field>

      <div fxFlex="5"></div>
    </div>

    <mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event,this)" [matSortActive]="parent.sortHeaderName" [matSortDirection]="parent.sortDirection" matSortDisableClear>
  
      <div *ngFor="let cols of displayedColumns" >
       
        <ng-container [matColumnDef]="cols" *ngIf="cols == 'View'">
          <mat-header-cell *matHeaderCellDef class="ngCustomWidth"> </mat-header-cell>
          <mat-cell *matCellDef="let row" class="ngCustomWidth" matTooltip="{{getToolTip('icoView')}}">
            <mat-icon  style="font-size:18px;color:rgb(0, 0, 0)" (click)="viewRecord($event)"  id="{{row['Id']}}">remove_red_eye</mat-icon>
          </mat-cell>
        </ng-container>

        <ng-container [matColumnDef]="cols" *ngIf="cols == 'Edit'">
          <mat-header-cell *matHeaderCellDef class="ngCustomWidth"> </mat-header-cell>
          <mat-cell *matCellDef="let row" class="ngCustomWidth" matTooltip="{{getToolTip('icoEdit')}}">
            <mat-icon  style="font-size:18px;color:orange" (click)="editRecord($event)"  id="{{row['Id']}}">edit</mat-icon>
          </mat-cell>
        </ng-container>

        <ng-container [matColumnDef]="cols" *ngIf="cols == 'Delete'">
          <mat-header-cell *matHeaderCellDef class="ngCustomWidth">  </mat-header-cell>
          <mat-cell *matCellDef="let row" class="ngCustomWidth" matTooltip="{{getToolTip('icoDelete')}}">
            <mat-icon style="font-size:18px;color:rgb(240, 98, 98)"  (click)="deleteRecord($event)" id="{{row['Id']}}">delete</mat-icon>
          </mat-cell>
        </ng-container> 

        <ng-container [matColumnDef]="cols" *ngIf="isCustomColumn(cols)">
            <mat-header-cell *matHeaderCellDef class="ngCustomWidth"></mat-header-cell>
            <mat-cell *matCellDef="let row" class="ngCustomWidth" matTooltip="{{getCustomControProp(cols,'ToolTip')}}">
                <mat-icon class="mat-icon material-icons {{getCustomControProp(cols,'Class')}}" 
                  (click)="customRecord($event)" id="{{row['Id']}}" [attr.code]="row['Code']"
                  style="font-size:18px;color: #02488e;">
                  {{getCustomControProp(cols,'Icon')}}</mat-icon> 
            </mat-cell>
        </ng-container>

        <ng-container [matColumnDef]="cols" *ngIf="cols != 'View' && cols != 'Edit' && cols != 'Delete' && !isCustomColumn(cols)">
          <mat-header-cell *matHeaderCellDef [mat-sort-header]="cols" [id]="cols" (click)="getColumnDetails($event)"> {{getColumnTranslation(cols)}} </mat-header-cell>
          <mat-cell *matCellDef="let row" class="truncate mat-cell-padding" [style.color]="getColumnColor(cols, row[cols], row)">
            <div *ngIf="!isIndicationColumn(cols)">{{row[cols]}}</div>
            <div *ngIf="isIndicationColumn(cols)" style="text-align: center;width:100%;" (click)="indicatorClicked($event)" id="{{row['Id']}}" [attr.data-invno]="row['InvoiceNo']" [attr.column]="cols" [attr.data-cname]="row['Client name']">
              <mat-icon matTooltip="{{row[cols]}}" [matTooltipDisabled]="row[cols] == undefined || row[cols] == ''" [style.color]="getColumnColor(cols, row[cols], row)">{{ getIndicatorIcon(cols, row[cols], row) }}</mat-icon>
            </div>
          </mat-cell>
        </ng-container>

      </div>

      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
  
    <mat-paginator #paginator [length]="parent.length" [pageSizeOtpions]="[10, 25, 50, 100]" (page)="getServerData($event)"></mat-paginator>
  </div>







// WEBPACK FOOTER //
// D:/Keval/Project/Mindport/HRS/hantraco-app/src/app/main/content/components/datatable/datatable.component.html